export const ReportTypes = ({ reportTypes }: any) => {
  return reportTypes.map((type: string, index: number) => {
    return <label>{`${type}${index === reportTypes.length - 1 ? '' : ', '}`}</label>;
  });
};
